import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRocket({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 18.143c0-.056-.003-.11-.01-.165l-.105-.833.803-.247c.338-.104.636-.284.862-.516l.348-.356 2.954.376c-.323-1.244-1.163-2.35-2.379-3.104L15 13.005V9.364c0-2.313-1.089-4.521-3-6.106-1.911 1.585-3 3.793-3 6.106v3.641l-.473.293c-1.216.754-2.056 1.86-2.38 3.104l2.955-.376.348.356c.226.232.524.412.862.516l.803.247-.105.834c-.006.053-.01.108-.01.164 0 .372.33 1.105 1 2.123.67-1.018 1-1.75 1-2.123zm-.2 4.456l-.8 1.07-.8-1.07c-1.294-1.729-2.022-3.046-2.171-4.074a4.03 4.03 0 01-.617-.395L4 18.69v-1.135c0-2.236 1.13-4.289 3-5.64V9.364c0-3.201 1.636-6.214 4.423-8.181L12 .776l.577.407C15.364 3.15 17 6.163 17 9.363v2.553c1.87 1.35 3 3.403 3 5.64v1.134l-4.412-.56c-.191.15-.398.282-.617.395-.149 1.028-.877 2.345-2.17 4.074zm-.8-12.6A1.5 1.5 0 1112 7a1.5 1.5 0 010 3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRocket
